import { SingletonFlowchart } from "../singletonFlowchart";
import { SingletonEnginnering } from "../singletonEngineering";

export const UpdateNode = {
  UpdateArea: function (strNodesList) {
    let nodeList = []
    for(let i in strNodesList){
      let jsonNode = strNodesList[i]
      let ctr = SingletonFlowchart.getController(jsonNode)
      
      if(!ctr)
        continue

      let objNode = ctr.getNode(jsonNode);
      objNode.data.forEach(p => p.value = SingletonEnginnering.getValue(p))
      nodeList.push(objNode);
    }
    return nodeList
  },

  EngineeringUpdate: async function(configuration){
    if(configuration.lenght){
      let properties = configuration
      await SingletonEnginnering.updatePropertyValues(properties);
    }
    return configuration
  }
}